import * as actionTypes from "./actionTypes";
import { retriveProductCart, getTotalPrice } from "./product-action";

// Aksi untuk menambah pesanan
export const incOrder = (tableNumber, Product) => ({
  type: actionTypes.INC_ORDER,
  tableNumber,
  Product,
});

// Aksi untuk mengurangi pesanan
export const decOrder = (tableNumber, Product) => ({
  type: actionTypes.DEC_ORDER,
  tableNumber,
  Product,
});

// Aksi untuk memperbarui jumlah pesanan
export const updateOrder = (tableNumber, ProductId, qty) => ({
  type: actionTypes.UPDATE_ORDER,
  tableNumber,
  ProductId,
  qty,
});

// Aksi untuk menghapus semua pesanan di satu meja
export const flushTable = (tableNumber) => ({
  type: actionTypes.FLUSH_TABLE,
  tableNumber,
});

// Aksi untuk menghapus semua pesanan di semua meja
export const flushAllOrders = () => ({
  type: actionTypes.FLUSH_ALL_ORDERS,
});

// Fungsi untuk memperbarui cart dan total harga
const updateCart = (dispatch) => {
  dispatch(retriveProductCart());
  dispatch(getTotalPrice());
};

// Handler untuk menambah pesanan
export const incOrderHandler = (tableNumber, Product) => {
  return (dispatch) => {
    dispatch(incOrder(tableNumber, Product));
    updateCart(dispatch); // Sinkronisasi cart dan harga total
  };
};

// Handler untuk mengurangi pesanan
export const decOrderHandler = (tableNumber, ProductId) => {
  return (dispatch) => {
    dispatch(decOrder(tableNumber, ProductId));
    updateCart(dispatch); // Sinkronisasi cart dan harga total
  };
};

// Handler untuk memperbarui jumlah pesanan
export const updateOrderHandler = (tableNumber, ProductId, qty) => {
  return (dispatch) => {
    dispatch(updateOrder(tableNumber, ProductId, qty));
    updateCart(dispatch); // Sinkronisasi cart dan harga total
  };
};

// Handler untuk menghapus semua pesanan di satu meja
export const flushTableHandler = (tableNumber) => {
  return (dispatch) => {
    dispatch(flushTable(tableNumber));
    updateCart(dispatch); // Sinkronisasi cart dan harga total
  };
};

// Handler untuk menghapus semua pesanan di semua meja
export const flushAllOrdersHandler = () => {
  return (dispatch) => {
    dispatch(flushAllOrders());
    updateCart(dispatch); // Sinkronisasi cart dan harga total
  };
};

// Handler tambahan untuk penghapusan dengan asinkron (opsional)
export const deleteOrderHandler = (tableNumber, ProductId) => {
  return (dispatch) => {
    dispatch(decOrder(tableNumber, ProductId));
    updateCart(dispatch);
  };
};
